import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { NotificationBell } from '@/shared/ui/navigation/NotificationBell';
import { useNotificationsUnreadCount } from '@/entities/notifications';

export const FeaturesNotificationsBell = () => {
  const { t } = useTranslation('notifications');
  const navigate = useNavigate();
  const { data } = useNotificationsUnreadCount();
  const count = data?.count ?? 0;

  const goToNotifications = (): void => {
    navigate('/notifications');
  };

  return <NotificationBell label={t('title')} count={count} onClick={goToNotifications} />;
};
